import { flashBagError, flashBagSuccess } from './tools/flashbag';
import translation from './tools/translations/translations';
import Logger from './tools/logger/logger';

export default function (selector, route) {
  document
    .querySelectorAll(selector)
    .forEach((element) => {
      element.addEventListener('click', () => {
        fetch(route, {
          method: 'POST',
          body: JSON.stringify({
            email: element.dataset.email,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.error) {
              flashBagError();
              Logger.error('Error occured', data.message);
            } else {
              flashBagSuccess(translation().messages['global.email.sent.to'].replace('%email%', element.dataset.email));
            }
          });
      });
    });
}
